import React from 'react';
import teamstyles from "./ourteamstyles.module.css"
import TeamCard from "../../components/teamCards/TeamCards"

import basestyles from "../../styles/basestyles.module.css"



const OurTeam = () => {
    return (
        <>
        <div id="ourteam" className={teamstyles.teamWrapper} >                   
            <div className={basestyles.maxWidth}>
                <div className={teamstyles.teamHeading}>
                    <h1>Our Team</h1>
                </div>    
                <div className={teamstyles.ourTeamCards}>                        
                    <TeamCard img="Praveen.jpeg" name= "Praveen Kumar" position="Founder and CEO"  whatsapp= "tel:+91 8951092604"
                    facebook= "https://www.facebook.com/profile.php?id=100001530686774" linkedin="https://www.linkedin.com/in/praveen-kumar-053a12201"/>      
                    
                    <TeamCard img="Pruthvi.jpeg" name="Pruthvi Raj" position="Founder" whatsapp="tel:+918951092635" facebook="https://www.facebook.com/pruthvimits" linkedin="https://www.linkedin.com/in/pruthvi-raj-719620136/  " />      

                    <TeamCard img="sharath.jpeg" name="Sharath Simha" position="Company Consultant" whatsapp="tel:+91 98453 55011" facebook="https://www.facebook.com/Sharathsimha1" linkedin="https://www.linkedin.com/in/sharath-simha-12165727"/>       
                </div>  
            </div>
        </div>
        </>
    );
}
 
 
export default OurTeam; 